import { Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'

const Auth0ProviderWithNavigate = ({ children, domain, clientId, audience }) => {
  const navigate = useNavigate()
  const isConfigured = Boolean(domain && clientId)

  if (!isConfigured) {
    return children
  }

  const onRedirectCallback = (appState) => {
    const target = appState?.returnTo || window.location.pathname
    navigate(target, { replace: true })
  }

  const authorizationParams = { redirect_uri: window.location.origin }
  if (audience) {
    authorizationParams.audience = audience
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation="localstorage"
      authorizationParams={authorizationParams}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithNavigate
